<div class="mainColumn">

	<div class="theCard">

		<div class="theLogo">
			<a
				[routerLink]="['/auth/login']"
				title="Startseite"
			>
				<img
					[src]="logoSrc || 'assets/logo.png'"
					style="max-width: 100%; margin: 0 0 2em 0; mix-blend-mode: darken;"
				>
			</a>
		</div>

		<div class="authTitle">
			Mitgliederportal Login
		</div>

		<form [hidden]="nStep != 1" [formGroup]="loginForm">

			<div id="middleColumn">

				<div>
					<triv-input [data]="username" [fGroup]="loginForm"></triv-input>

					<app-password-input [data]="password" [fGroup]="loginForm"></app-password-input>

				</div>

				<div
					*ngIf="lastResult != AuthResult.OK"
					style="margin: 1em; color: red;"
				>
					{{errorMsgs[lastResult]}}
				</div>

				<button
					mat-raised-button
					[ngStyle]="{ 'background-color': (changeButtonColor && !bInProgress) ? 'var(--mainColor)' : '','color': changeButtonColor ? 'var(--customWhite)' : '' }"
					[disabled]="loginForm.invalid || bInProgress"
					(click)="loginStep1()"
					style="width: 100%;"
				>
					Anmelden
				</button>

				<a
					class="trivLink"
					style="opacity: .5"
					[routerLink]="['/login/passwort-vergessen']"
				>
					Passwort vergessen?
				</a>

		@if( showRegistrationLink ) {
			<a
			class="trivLink"
			style="margin-top: 1em; font-weight: 500;"
			[routerLink]="['/auth/register']"
			>
			Noch keinen Account? Jetzt registrieren
			</a>
		}

			</div>

		</form>

		<div [hidden]="nStep != 2">

			<div style="display: flex; flex-flow: column nowrap; gap: 1em;">

				<div *ngIf="secondStepType == SecondStepType.authenticator">

					<div style="margin: 1em 0; font-size: large;">
						Authenticator
					</div>
					<div>
						Bitte geben Sie den Code aus dem Authenticator ein:
					</div>

				</div>
				<div *ngIf="secondStepType == SecondStepType.email">

					<div style="margin: 1em 0; font-size: large;">
						E-Mail
					</div>
					<div *ngIf="bRequestForEmailFailed && !bInProgress" style="color: red;">
						Beim Senden der E-Mail an Sie ist ein Fehler aufgetreten. Bitte wenden Sie sich an Ihren Administrator
					</div>
					<div *ngIf="!bRequestForEmailFailed && !bInProgress">
						Ein Code wurde an Ihre E-Mail-Adresse gesendet. Bitte schreiben Sie es hier auf:
					</div>

				</div>

				<totp-input (totpReady)="onTotpReady($event)" />

				<div style="text-align: center; display: flex; flex-flow: column nowrap; align-items: center; gap: 2em; align-items: stretch">

					<button
						mat-flat-button
						[disabled]="bInProgress || totpCode.length != 6"
						(click)="loginStep2()"
						color="primary"
						[ngStyle]="{ 'background-color': (changeButtonColor && !bInProgress) ? 'var(--mainColor)' : '','color': changeButtonColor ? 'var(--customWhite)' : '' }"
					>
						Anmelden
					</button>

					@if(  ( secondStepType == SecondStepType.email ) && bShowResendBtn  ) {

						<button
							mat-raised-button
							[disabled]="bInProgress"
							(click)="resendEmail()"
						>
							Code per E-Mail erneut senden
						</button>

					}

				</div>
			</div>
		</div>

		<mat-progress-bar
			*ngIf="bInProgress"
			mode="indeterminate"
			style="margin: 1em 0 0 0"
		/>

	</div>



	<footer-login></footer-login>

</div>
